import { matchPath } from "react-router-dom";

let rootUrl = "/driverportal/:customer";

/**
 * Non-empty customer/realm string, excluding legacy bad persisted values.
 * (Older builds defaulted Redux to the literal string "undefined" and persisted it.)
 */
export function isValidCustomerName(value) {
  return (
    typeof value === "string" &&
    value.length > 0 &&
    value !== "undefined" &&
    value !== "null"
  );
}

/**
 * Realm / customer segment from the current URL (single source of truth fallback).
 */
export function getCustomerFromPath(pathname = window.location.pathname) {
  const m = matchPath(pathname, { path: "/driverportal/:customer" });
  const c = m?.params?.customer;
  return isValidCustomerName(c) ? c : null;
}

/**
 * Prefer a valid store value; otherwise parse from pathname (handles legacy persisted "undefined").
 */
export function resolveCustomerName(stored, pathname) {
  if (isValidCustomerName(stored)) {
    return stored;
  }
  return getCustomerFromPath(pathname);
}

export const Routes = {
  ROOT: rootUrl,
  LOGIN: rootUrl + "/login",
  SECURITY: rootUrl + "/securitypage",
  FORGETPASSWORD: rootUrl + "/forgetpassword",
  FORGETUSERNAME: rootUrl + "/forgetusername",
  DASHBOARD: rootUrl + "/dashboard",
  VERIFYDASHBOARD: rootUrl + "/verify-dashboard",
  REGISTRATION: rootUrl + "/register",
  REGISTRATIONSUCCESS: rootUrl + "/register/success",
  RESETPASSWORD: rootUrl + "/resetpassword/:name",
  RESETPASSWORDSTATUS: rootUrl + "/forget-password/status",
  RESETUSERNAMESTATUS: rootUrl + "/forget-username/status",
  PRIVACY: rootUrl + "/privacy",
  PRIVACY_POLICY: rootUrl + "/privacy-policy",
  PCICOMPLIANCE: rootUrl + "/pciCompliance",
  PAYCITATION: rootUrl + "/paycitation",
  RESETPASSWORDSUCCESS: rootUrl + "/reset-password/success",
  PROFILEPAGE: rootUrl + "/profile",
  CITATION: rootUrl + "/citation",
  PAYCITATIONFORMPAGE: rootUrl + "/paycitation-form",
  CITATIONDETAILS: rootUrl + "/citation-details/:citationId/:licenseId",
  CITATIONDETAILSPDF: rootUrl + "/citation-actions/download-citation/:ClientName/:citationId",
  CITATIONPAYMENTSTATUS: rootUrl + "/citation-payment/status",
  VIEWORDERS: rootUrl + "/vieworders",
  BUYPERMITS: rootUrl + "/buyPermits",
  PERMIT_PAYMENT_STATUS: rootUrl + "/permit-payment-status",
  VERIFYEMAIL: rootUrl + "/email-status/:clientUsername",
  VISITORPERMIT: rootUrl + "/visitorPermit",
  VISITORPERMITFORM: rootUrl + "/visitorPermitForm",
  INCOMPLETEPAYMENT: rootUrl + "/incompletePayment",
};
export const RouteService = {
  login: (customerName) => {
    return `/driverportal/${customerName}/login`;
  },
  home: (customerName) => {
    return `/driverportal/${customerName}`;
  },
  incompletePayment: (customerName) => {
    return `/driverportal/${customerName}/incompletePayment`;
  },
  forgetPassword: (customerName) => {
    return `/driverportal/${customerName}/forgetpassword`;
  },
  forgetUserName:(customerName)=>{
    return `/driverportal/${customerName}/forgetusername`;
  },
  resetPassword: (customerName) => {
    return `/driverportal/${customerName}/resetpassword`;
  },
  resetPasswordStatus: (customerName) => {
    return `/driverportal/${customerName}/forget-password/status`;
  },
  resetUsernameStatus: (customerName) => {
    return `/driverportal/${customerName}/forget-username/status`;
  },
  registrationSuccess: (customerName) => {
    return `/driverportal/${customerName}/register/success`;
  },
  registration: (customerName) => {
    return `/driverportal/${customerName}/register`;
  },
  privacyPolicy: (customerName) => {
    return `/driverportal/${customerName}/privacy-policy`;
  },
  dashboard: (customerName) => {
    return `/driverportal/${customerName}/dashboard`;
  },
  verifyDashboard: (customerName) => {
    return `/driverportal/${customerName}/verify-dashboard`;
  },
  payCitation: (customerName) => {
    return `/driverportal/${customerName}/paycitation`;
  },
  citation: (customerName) => {
    return `/driverportal/${customerName}/citation`;
  },
  resetPasswordSuccess: (customerName) => {
    return `/driverportal/${customerName}/reset-password/success`;
  },
  profilePage: (customerName) => {
    return `/driverportal/${customerName}/profile`;
  },
  viewOrders: (customerName) => {
    return `/driverportal/${customerName}/vieworders`;
  },
  securityPage: (customerName) => {
    return `/driverportal/${customerName}/securitypage`
  },
  buyPermits: (customerName) => {
    return `/driverportal/${customerName}/buyPermits`;
  },
  permitPaymentStatus: (customerName) => {
    return `/driverportal/${customerName}/permit-payment-status`;
  },
  verifyEmail: (customerName) => {
    return `/driverportal/${customerName}/email-status`;
  },
  visitorPermit: (customerName) => {
    return `/driverportal/${customerName}/visitorPermit`;
  },
  visitorPermitForm: (customerName) => {
    return `/driverportal/${customerName}/visitorPermitForm`;
  },
  payCitationForm: (customerName) =>
    `/driverportal/${customerName}/paycitation-form`,
  citationDetails: (customerName) =>
    `/driverportal/${customerName}/citation-details`,
  citationPaymentStatus: (customerName) =>
    `/driverportal/${customerName}/citation-payment/status`,
  citationDetail: (customerName, licenseId, citationId) =>
    `/driverportal/${customerName}/citation-details/${licenseId}/${citationId}`,
  citationDetailPDF: (customerName, ClientName, citationId) =>
    `/driverportal/${customerName}/citation-actions/download-citation/${ClientName}/${citationId}`,
};
